import { combineReducers } from 'redux'

import arquivosBensImoveis from './arquivosBensImoveis'

export default combineReducers({ arquivosBensImoveis })
